var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 18V11M11 18V8M3 18L3 14M12.4067 3.0275L17.5751 4.96567M9.79877 3.40092L4.20023 7.59983M20.0607 4.43934C20.6464 5.02513 20.6464 5.97487 20.0607 6.56066C19.4749 7.14645 18.5251 7.14645 17.9393 6.56066C17.3536 5.97487 17.3536 5.02513 17.9393 4.43934C18.5251 3.85355 19.4749 3.85355 20.0607 4.43934ZM4.06066 7.43934C4.64645 8.02513 4.64645 8.97487 4.06066 9.56066C3.47487 10.1464 2.52513 10.1464 1.93934 9.56066C1.35355 8.97487 1.35355 8.02513 1.93934 7.43934C2.52513 6.85355 3.47487 6.85355 4.06066 7.43934ZM12.0607 1.43934C12.6464 2.02513 12.6464 2.97487 12.0607 3.56066C11.4749 4.14645 10.5251 4.14645 9.93934 3.56066C9.35355 2.97487 9.35355 2.02513 9.93934 1.43934C10.5251 0.853553 11.4749 0.853553 12.0607 1.43934Z",
    stroke: "#F0F5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.ef245d35680ad6cd942e04218539554f.svg";
export { ForwardRef as ReactComponent };